import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import { init } from './dataEspecialActions';
import LabelAndInput from '../common/form/labelAndInput';
import Button from '../common/form/button';
import Checkbox from '../common/form/checkbox';

import SelectPlano from '../common/selectdb/selectPlano';
import SelectMes from './selectMes';
import SelectDia from './selectDia';
import html2canvas from 'html2canvas';
import { toastr } from 'react-redux-toastr';
import ProcessingOverlay from '../common/components/processingOverlay';
import axiosInstance from '../main/axios';

class DataEspecialForm extends Component {
  constructor(props) {
    super(props);

    this.componentRef = React.createRef();

    this.salvarDataEspecial = this.salvarDataEspecial.bind(this);
    this.applyDateRulesIfNeeded = this.applyDateRulesIfNeeded.bind(this);
    this.handleChangePlano = this.handleChangePlano.bind(this);
    this.handleDateFieldChange = this.handleDateFieldChange.bind(this);
    this.formatFormErrors = this.formatFormErrors.bind(this);

    this.userChangedDate = false;

    this.state = {
      show: false,
      planoId: '',
    };
  }

  getAnoEfetivo(mes, dia) {
    const now = new Date();
    const y = now.getFullYear();
    const m = now.getMonth() + 1;
    const d = now.getDate();
    const selM = Number(mes);
    const selD = Number(dia);

    if (selM < m || (selM === m && selD < d)) {
      return y + 1;
    }

    return y;
  }

  normalizeHorario(horario) {
    if (!horario) {
      return '';
    }

    return String(horario).substring(0, 5);
  }

  isPlanoVirtual(planoId) {
    const id = parseInt(planoId, 10);
    return id === 63 || id === 32;
  }

  validaDuplicataLocal() {
    const list = this.props.list || [];
    const idAtual = parseInt(this.props.registro_id, 10) || 0;
    const mes = parseInt(this.props.data_mes, 10);
    const dia = parseInt(this.props.data_dia, 10);
    const horaIni = this.normalizeHorario(this.props.horario_inicial);
    const horaFim = this.normalizeHorario(this.props.horario_final);
    const anoAlvo = this.getAnoEfetivo(mes, dia);

    const duplicado = list.find(item => {
      if (idAtual && parseInt(item.id, 10) === idAtual) {
        return false;
      }

      if (Number(item.mes) !== mes || Number(item.dia) !== dia) {
        return false;
      }

      if (this.getAnoEfetivo(item.mes, item.dia) !== anoAlvo) {
        return false;
      }

      return (
        this.normalizeHorario(item.horario_inicial) === horaIni &&
        this.normalizeHorario(item.horario_final) === horaFim
      );
    });

    if (duplicado) {
      toastr.error(
        'Data duplicada',
        `Já existe uma data especial para ${String(dia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${anoAlvo} no horário ${horaIni} às ${horaFim}.`,
      );
      return false;
    }

    return true;
  }

  formatFormErrors(errors) {
    const labels = {
      plano_id: 'Plano',
      mes: 'Mês',
      dia: 'Dia',
      horario_inicial: 'Horário inicial',
      horario_final: 'Horário final',
    };

    const messages = Object.keys(errors || {})
      .map(key => {
        const value = errors[key];
        if (!value) {
          return null;
        }

        return `${labels[key] || key}: ${value}`;
      })
      .filter(Boolean);

    return messages.length > 0 ? messages.join(' ') : 'Preencha os campos obrigatórios.';
  }

  async salvarDataEspecial() {
    const mes = parseInt(this.props.data_mes, 10);
    const dia = parseInt(this.props.data_dia, 10);

    if (!Number.isFinite(mes) || !Number.isFinite(dia) || mes <= 0 || dia <= 0) {
      toastr.error('Validação', 'Informe mês e dia da data especial.');
      return;
    }

    const ano = this.getAnoEfetivo(mes, dia);
    const dataEspecial = new Date(ano, mes - 1, dia);
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    dataEspecial.setHours(0, 0, 0, 0);

    if (dataEspecial <= hoje) {
      toastr.error(
        'Data Inválida',
        'Não é permitido salvar uma data especial para uma data passada ou o dia atual. Escolha uma data futura.',
      );
      return;
    }

    if (!this.validaDuplicataLocal()) {
      return;
    }

    const planoId = this.props.plano_id;
    if (this.isPlanoVirtual(planoId)) {
      const aneisMarcados = [1, 2, 3, 4].some(index => this.props[`anel${index}`]);
      if (!aneisMarcados) {
        toastr.error('Anéis', 'Selecione ao menos um anel para plano intermitente ou apagado.');
        return;
      }
    }

    // Pré-validação do plano selecionado para o controlador atual
    try {
      const contId = this.props.controlador_id;
      if (contId && parseInt(contId, 10) !== 0 && planoId && planoId !== '0' && !this.isPlanoVirtual(planoId)) {
        await axiosInstance.get(`/trocaplanos/validar-plano/${contId}/${planoId}`);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const message = error.response.data.message;
        toastr.error('Plano Inválido', message);
        return;
      }

      toastr.error('Erro', 'Erro ao validar plano. Tente novamente.');
      return;
    }

    this.setState({ show: true });

    try {
      await html2canvas(this.componentRef.current).then(canvas => {
        canvas.style.display = 'none';
        const image = canvas.toDataURL('png');
        this.props.change('imageLog', image);
      });

      this.props.handleSubmit(
        this.props.onSubmit,
        errors => {
          toastr.error('Validação', this.formatFormErrors(errors));
        },
      )();
    } catch (error) {
      toastr.error('Erro', error.message || 'Erro ao salvar data especial');
    } finally {
      this.setState({ show: false });
    }
  }

  async handleChangePlano(event) {
    const planoId = event && event.target ? event.target.value : undefined;
    const contId = this.props.controlador_id;

    this.setState({ planoId: planoId || '' });

    if (planoId && planoId !== '0') {
      if (this.isPlanoVirtual(planoId)) {
        this.props.change('anel1', 1);
        this.props.change('anel2', 1);
        this.props.change('anel3', 1);
        this.props.change('anel4', 1);
      } else {
        this.props.change('anel1', 0);
        this.props.change('anel2', 0);
        this.props.change('anel3', 0);
        this.props.change('anel4', 0);
      }
    }

    if (!planoId || planoId === '0' || this.isPlanoVirtual(planoId) || !contId || parseInt(contId, 10) === 0) {
      return;
    }

    try {
      await axiosInstance.get(`/trocaplanos/validar-plano/${contId}/${planoId}`);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const message = error.response.data.message;
        toastr.error('Plano Inválido', message);
        // Limpa o campo de plano
        this.props.change('plano_id', '0');
      } else {
        toastr.error('Erro', 'Erro ao validar plano. Tente novamente.');
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.plano_id !== this.props.plano_id && this.props.plano_id) {
      this.setState({ planoId: String(this.props.plano_id) });
    }

    if (prevProps.data_mes !== this.props.data_mes || prevProps.data_dia !== this.props.data_dia) {
      if (!this.props.data_mes && !this.props.data_dia) {
        this.userChangedDate = false;
      }
      this.applyDateRulesIfNeeded();
    }
  }

  applyDateRulesIfNeeded() {
    const mes = parseInt(this.props.data_mes, 10);
    const dia = parseInt(this.props.data_dia, 10);
    if (!Number.isFinite(mes) || !Number.isFinite(dia) || mes <= 0 || dia <= 0) return;

    const now = new Date();
    const todayMonth = now.getMonth() + 1; // 1-12
    const todayDay = now.getDate(); // 1-31

    // Se for exatamente hoje: avança para o próximo dia (com rollover de mês/ano)
    if (mes === todayMonth && dia === todayDay) {
      // calcula dias no mês atual
      const daysInMonth = new Date(now.getFullYear(), mes, 0).getDate();
      let novoDia = dia + 1;
      let novoMes = mes;
      if (novoDia > daysInMonth) {
        novoDia = 1;
        novoMes = mes === 12 ? 1 : mes + 1;
      }
      this.props.change('mes', novoMes);
      this.props.change('dia', novoDia);
      toastr.warning(
        'Atenção',
        'Não é permitido adicionar uma data especial com a mesma data do dia atual, escolha outro dia.',
        { position: 'top-right' },
      );
      return;
    }

    // Se a data escolhida (mes/dia) for anterior à data atual, avisa apenas durante a seleção manual
    const ano = this.getAnoEfetivo(mes, dia);
    const dataEspecial = new Date(ano, mes - 1, dia);
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    dataEspecial.setHours(0, 0, 0, 0);

    if (this.userChangedDate && dataEspecial <= hoje) {
      toastr.warning('Data Inválida', 'A data selecionada já passou. Por favor, escolha uma data futura.', {
        position: 'top-right',
      });
    }
  }

  handleDateFieldChange() {
    this.userChangedDate = true;
  }

  render() {
    const { handleSubmit, controlador_id, data_mes, plano_id } = this.props;
    const planoSelecionado = this.state.planoId || plano_id || '';
    const aneisHabilitados = this.isPlanoVirtual(planoSelecionado);
    const requiredSelect = value =>
      value === '0' || value === undefined || value === '' || value === null ? 'Obrigatório' : undefined;
    const requiredTime = value => (value === undefined || value === '' ? 'Obrigatório' : undefined);

    return (
      <form onSubmit={handleSubmit} ref={this.componentRef} className="simple-cad-form-premium">
        <ProcessingOverlay
          show={this.state.show}
          message={
            <>
              Salvando data especial...
              <small>Aguarde, processando dados do formulário.</small>
            </>
          }
          tagline="Datas Especiais"
        />
        <div className="simple-cad-premium-container">
          <div className="simple-cad-premium-card">
            <div className="simple-cad-premium-header">
              <h4>
                <i className="fa fa-calendar-alt" /> Data Especial
              </h4>
              <p>Configure plano, data, horários e anéis para a programação especial.</p>
            </div>
            <div className="simple-cad-premium-body">
              <Field
                name="sequencia"
                component={LabelAndInput}
                cols="12 4"
                label="Código"
                placeholder="Automático"
                readOnly={true}
              />

              <SelectPlano
                cols="12 4"
                data-controlador-id={controlador_id}
                data-plano-piscante={true}
                onChange={this.handleChangePlano}
                validate={requiredSelect}
              />

              <SelectMes cols="12 4" validate={requiredSelect} onChange={this.handleDateFieldChange} />
              <SelectDia cols="12 4" data-mes={data_mes || ''} validate={requiredSelect} onChange={this.handleDateFieldChange} />

              <Field
                name="horario_inicial"
                component={LabelAndInput}
                type="time"
                cols="12 4"
                label="Horário Inicial"
                validate={requiredTime}
              />

              <Field
                name="horario_final"
                component={LabelAndInput}
                type="time"
                cols="12 4"
                label="Horário Final"
                validate={requiredTime}
              />

              <div className="data-especial-premium-aneis">
                <div className="data-especial-premium-aneis-title">Anéis</div>
                <Field
                  cols="6 3"
                  name="anel1"
                  component={Checkbox}
                  label="Anel 1"
                  type="checkbox"
                  disabled={aneisHabilitados ? '' : 'disabled'}
                />
                <Field
                  cols="6 3"
                  name="anel2"
                  component={Checkbox}
                  label="Anel 2"
                  type="checkbox"
                  disabled={aneisHabilitados ? '' : 'disabled'}
                />
                <Field
                  cols="6 3"
                  name="anel3"
                  component={Checkbox}
                  label="Anel 3"
                  type="checkbox"
                  disabled={aneisHabilitados ? '' : 'disabled'}
                />
                <Field
                  cols="6 3"
                  name="anel4"
                  component={Checkbox}
                  label="Anel 4"
                  type="checkbox"
                  disabled={aneisHabilitados ? '' : 'disabled'}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="simple-cad-premium-footer">
          <Button type="button" className="primary" icon="check" label="Salvar" onClick={this.salvarDataEspecial} />
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
        </div>
      </form>
    );
  }
}

// destroyOnUnmount: false permite utilizar o mesmo componente form para cadastrar e para alterar, se tirar essa propriedade o sistema cria um
// form limpo para o update
DataEspecialForm = reduxForm({ form: 'dataEspecialForm', destroyOnUnmount: false })(DataEspecialForm);

const selector = formValueSelector('dataEspecialForm');
const mapStateToProps = state => ({
  controlador_id: selector(state, 'controlador_id') || 0,
  data_mes: selector(state, 'mes'),
  data_dia: selector(state, 'dia'),
  plano_id: selector(state, 'plano_id') || '0',
  horario_inicial: selector(state, 'horario_inicial'),
  horario_final: selector(state, 'horario_final'),
  registro_id: selector(state, 'id'),
  anel1: selector(state, 'anel1'),
  anel2: selector(state, 'anel2'),
  anel3: selector(state, 'anel3'),
  anel4: selector(state, 'anel4'),
  list: state.dataEspecialCad.list,
});

const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataEspecialForm);
